/**
 * Evidence Hub — Page Exports
 *
 * Each page uses its dedicated component:
 *   Upload & Ingest     → UploadIngestPage.js
 *   Evidence Library     → EvidenceLibraryPage.js
 *   Cross-Framework Map  → CrossFrameworkMapPage.js
 *   Ownership & Approval → OwnershipApprovalPage.js
 */
import UploadIngestComponent from './UploadIngestPage';
import EvidenceLibraryComponent from './EvidenceLibraryPage';
import CrossFrameworkMapComponent from './CrossFrameworkMapPage';
import OwnershipApprovalComponent from './OwnershipApprovalPage';

export function UploadIngestPage() {
  return <UploadIngestComponent />;
}

export function EvidenceLibraryPage() {
  return <EvidenceLibraryComponent />;
}

export function CrossFrameworkMapPage() {
  return <CrossFrameworkMapComponent />;
}

export function OwnershipApprovalPage() {
  return <OwnershipApprovalComponent />;
}

export default EvidenceLibraryPage;

// Re-export detail page that is NOT migrated (has its own deep-link UI)
export { default as SingleEvidenceDetailPage } from './SingleEvidenceDetailPage';
